
import { JsonObject, JsonProperty } from 'json2typescript';
import { Lawyer, LawyerLite } from '../lawyers/lawyer';
import { HistoryActionTypeEnum } from '../shared-enums';
import { User } from '../users/user';

export enum PositionEnum {
    SENIOR = 1,
    JUNIOR = 2,
}

@JsonObject('CaseLawyer')
export class CaseLawyer {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('lawyer', LawyerLite, true)
    lawyer: LawyerLite = null;

    @JsonProperty('position', String, true)
    position = null;

    @JsonProperty('rate', Number, true)
    rate = undefined;

    // write data
    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('lawyer_id', Number, true)
    lawyerId: number = undefined;

    get getName() {
        return this.lawyer.getName;
    }

    get getPosition() {
        return PositionEnum[this.position];
    }
}

@JsonObject('CaseLawyerHistory')
export class CaseLawyerHistory extends CaseLawyer {
    @JsonProperty('history_id', Number, true)
    historyId: number = undefined;

    @JsonProperty('history_user', User, true)
    user: User = null;

    @JsonProperty('history_type', String, true)
    historyType: HistoryActionTypeEnum = null;

    @JsonProperty('history_change_reason', String, true)
    changeReason = null;

    @JsonProperty('history_date', String, true)
    date = null;

    get historyTypeStr() {
        return this.isCreate ? 'Added' : (this.isUpdate ? 'Updated' : 'Removed');
    }

    get isCreate() {
        return this.historyType === HistoryActionTypeEnum.ADDED
    }

    get isUpdate() {
        return this.historyType === HistoryActionTypeEnum.UPDATED
    }

    get isDelete() {
        return this.historyType === HistoryActionTypeEnum.REMOVED
    }
}